import { createActionGroup, props } from '@ngrx/store';
import { Permission } from '@qtek/shared/models';

export const PermissionsActions = createActionGroup({
  source: 'Permissions',
  events: {
    'Set Permissions': props<{ permissions: Permission[] }>(),
  },
});
